var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiSlightlySmilingFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 40.0005C11.018 40.0005 0.248779 33.7393 0.248779 20.0005C0.248779 6.26167 11.018 0.000488281 21.0001 0.000488281C26.5457 0.000488281 31.662 1.82517 35.4545 5.15254C39.569 8.80192 41.7515 13.954 41.7515 20.0005C41.7515 26.047 39.569 31.1633 35.4545 34.8127C31.662 38.14 26.51 40.0005 21.0001 40.0005Z",
    fill: "url(#paint0_radial_390_2465)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9875 12.1436C12.4884 12.1436 11.1252 13.4101 11.1252 15.5139C11.1252 17.6176 12.4884 18.8806 13.9875 18.8806C15.4902 18.8806 16.8498 17.614 16.8498 15.5139C16.8498 13.4137 15.5045 12.1436 13.9875 12.1436Z",
    fill: "#422B0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8624 13.5497C13.3544 13.3064 12.7426 13.5211 12.4957 14.0292C12.3061 14.4263 12.392 14.9021 12.7104 15.2098C13.2184 15.4531 13.8302 15.2385 14.0771 14.7304C14.2667 14.3333 14.1809 13.8574 13.8624 13.5497Z",
    fill: "#896024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7265 12.1436C26.2274 12.1436 24.8643 13.4101 24.8643 15.5139C24.8643 17.6176 26.2274 18.8806 27.7265 18.8806C29.2256 18.8806 30.5888 17.614 30.5888 15.5139C30.5888 13.4137 29.2256 12.1436 27.7265 12.1436Z",
    fill: "#422B0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5831 13.5497C27.0751 13.3064 26.4633 13.5211 26.2164 14.0292C26.0268 14.4263 26.1127 14.9021 26.4311 15.2098C26.9391 15.4531 27.5509 15.2385 27.7978 14.7304C27.9874 14.3333 27.9016 13.8574 27.5831 13.5497Z",
    fill: "#896024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7855 30.2724C17.5404 30.2974 14.442 28.9343 12.2703 26.5228C12.1057 26.3332 12.0663 26.0648 12.1701 25.8359C12.2738 25.6033 12.5028 25.453 12.7569 25.4495C12.8713 25.4495 12.9858 25.4817 13.086 25.5389C14.8105 26.53 17.6942 27.7607 20.7855 27.7607H20.8356C23.9232 27.7607 26.8105 26.53 28.5315 25.5389C28.6316 25.4817 28.7461 25.4495 28.8606 25.4495C29.1146 25.453 29.3436 25.6033 29.4474 25.8359C29.5547 26.0648 29.5154 26.3332 29.3472 26.5228C27.1755 28.9343 24.0699 30.301 20.8248 30.2724",
    fill: "#422B0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1343 8.11108C40.0413 11.188 41.0359 14.8517 41.0359 18.9268C41.0359 24.9733 38.8534 30.0896 34.7389 33.739C30.9464 37.0664 25.7944 38.9268 20.2846 38.9268C13.823 38.9268 7.04663 36.2971 3.04663 30.7193C6.89636 37.0377 14.1379 40.0002 21.0001 40.0002C26.51 40.0002 31.662 38.1397 35.4545 34.8123C39.569 31.163 41.7515 26.0467 41.7515 20.0002C41.7515 15.442 40.51 11.3919 38.1343 8.11108Z",
    fill: "#EB8F00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_390_2465",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0001 20.0005) scale(20.3791 20.3791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSlightlySmilingFace);
export default __webpack_public_path__ + "static/media/emoji-slightly-smiling-face.911664b5cf31778cdb27f7aa5a9a8f80.svg";
export { ForwardRef as ReactComponent };